import { createFileRoute } from '@tanstack/react-router'
import { EmployeeCenterPage } from '@/components/employee-center/EmployeeCenterPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/',
)({
  component: EmployeeCenterPage,
})
